import { render, staticRenderFns } from "./ProfileTalentPackagesListItem.vue?vue&type=template&id=b0676abc&scoped=true"
import script from "./ProfileTalentPackagesListItem.vue?vue&type=script&lang=js"
export * from "./ProfileTalentPackagesListItem.vue?vue&type=script&lang=js"
import style0 from "./ProfileTalentPackagesListItem.vue?vue&type=style&index=0&id=b0676abc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0676abc",
  null
  
)

export default component.exports